import { Roles } from '../models/roles.model'
import * as RolesActions from '../actions/roles.action'

// 初始化数据值
const initialState: Roles = []

export function reducer(state: Roles = initialState, action: RolesActions.RolesActions) {

  let newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case RolesActions.ADD_ROLE:
      newState.push(action.payload);
      return newState;
    case RolesActions.REMOVE_ROLE:
      newState.filter(o=>o.roleId!=action.payload)
      return newState;
    case RolesActions.CLEAR_ROLE:
      return [];
    default:
      return state;
  }
}